import { Link } from 'react-router-dom'
import './Header.css'

const ASCII_LOGO = `▗▖ ▗▖ ▗▄▖ ▗▄▄▖ ▗▖  ▗▖▗▄▄▄▖ ▗▄▄▖ ▗▄▄▖
▐▌ ▐▌▐▌ ▐▌▐▌ ▐▌▐▛▚▖▐▌▐▌   ▐▌   ▐▌
▐▛▀▜▌▐▛▀▜▌▐▛▀▚▖▐▌ ▝▜▌▐▛▀▀▘ ▝▀▚▖ ▝▀▚▖
▐▌ ▐▌▐▌ ▐▌▐▌ ▐▌▐▌  ▐▌▐▙▄▄▖▗▄▄▞▘▗▄▄▞▘`

export function Header() {
  return (
    <header className="header">
      <div className="header__container">
        <div className="header__content">
          <Link to="/" className="header__logo">
            <pre className="ascii-logo">{ASCII_LOGO}</pre>
          </Link>
          <nav className="header__nav">
            <Link to="/api" className="header__link">API</Link>
            {/* <a href="/signin" className="header__link">Sign In</a> */}
          </nav>
        </div>
        <div className="header__divider">
          {'-'.repeat(119)}
        </div>
      </div>
    </header>
  )
}
